import React from 'react';
import { Grid } from '@mui/material';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { SyncRuleDto } from '../../../../services/redux/api/syncApi';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  canEdit: boolean,
  canDelete: boolean,
  onEdit: (rule: SyncRuleDto) => void,
  onDelete: (rule: SyncRuleDto) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.PROVIDER,
      cellReducer: (rule: SyncRuleDto) => {
        return <div>{rule.provider}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.ENTITY,
      cellReducer: (rule: SyncRuleDto) => {
        return <div>{rule.entity}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.SOURCE_PATH,
      cellReducer: (rule: SyncRuleDto) => {
        return <div>{rule.sourcePath}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.DEFAULT_VALUE,
      cellReducer: (rule: SyncRuleDto) => {
        return <div>{rule.defaultValue}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.LOCAL_PATH,
      cellReducer: (rule: SyncRuleDto) => {
        return <div>{rule.localPath}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.PREFIX,
      cellReducer: (rule: SyncRuleDto) => {
        return <div>{rule.prefix}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.TRANSFORM,
      cellReducer: (rule: SyncRuleDto) => {
        return <div>{rule.transform ?? 'none'}</div>;
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (rule: SyncRuleDto) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(rule);
                        }}
                      />
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(rule);
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
